import Icon from './Icon.jsx'
import { formatDate } from '../lib/dates.js'

/**
 * The other periods already booked, each with a way to remove it.
 *
 * Shared by the time-off dialog and the out-of-service dialog, which had grown identical
 * copies of this list: one date, or a from–to pair, then whatever the period says about itself
 * — the hours and the note for an absence, the reason for a repair — and a trash button. The
 * two rows differed only in that second part, so it is a function the caller supplies.
 *
 * @param detail  (period) => string | null — what follows the dates on the row
 */
export default function ExistingPeriods({ periods, detail, onRemove }) {
  return (
    <ul className="timeoff-list">
      {periods.map((p) => {
        const extra = detail?.(p)
        return (
          <li key={p.id}>
            <span>
              {formatDate(p.from)}
              {p.to !== p.from ? ` – ${formatDate(p.to)}` : ''}
              {extra ? ` · ${extra}` : ''}
            </span>
            <button type="button" className="icon-btn" title="Remove" aria-label="Remove" onClick={() => onRemove(p.id)}>
              <Icon name="trash" size={15} />
            </button>
          </li>
        )
      })}
    </ul>
  )
}
